export enum SignalMode {
  NULLABLE,
  REQUIRED,
  REPEATED
}